const firebaseCollections = {
    thewall: "TheWall",
    articles: "Articles",
    users: "Users",
};

const postTypesArr = ["Feedback Type", "Operational Feedback", "Office Evnironment", "Training Request"];
const visibilityStatesArr = ["Public", "Private"];
const calendarStrings = {
    lastDay: '[Yesterday at] LT',
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    lastWeek: '[last] dddd [at] LT',
    nextWeek: 'dddd [at] LT',
    sameElse: 'L'
}

const asanaAPIToken = "1/531187398242434:8494c3353db0bcb6fe40b6d7809a4a7d";

export { firebaseCollections, postTypesArr, visibilityStatesArr, calendarStrings };